export default __webpack_public_path__ + "76b15dbdaf7195c9d044f5e4cae5763f.png";